import createAPI from '../axios'
import config from "../../views/siteManage/config.vue";

//基础信息相关API

const summaryStatistics = {
    adultEducation: {
        initCombo: config => createAPI('/summaryStatistics/adultEducation/initCombo', 'post', config),
        queryList: config => createAPI('/summaryStatistics/adultEducation/queryList', 'post', config),
    },
    skillsTraining: {
        initCombo: config => createAPI('/summaryStatistics/skillsTraining/initCombo', 'post', config),
        querySchoolEnterpriseCooperationList: config => createAPI('/summaryStatistics/skillsTraining/querySchoolEnterpriseCooperationList', 'post', config),
        querySkillsTrainingList: config => createAPI('/summaryStatistics/skillsTraining/querySkillsTrainingList', 'post', config),
    }
};

export default summaryStatistics;



// WEBPACK FOOTER //
// ./src/api/modules/summaryStatistics.js